exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a:hover, a:active, a:focus, a:visited {\n  text-decoration: none;\n  border-bottom: none;\n}\n@media print {\na.float-right {\n    display: none;\n}\n}", ""]);

// exports
